import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/application/login.service';

@Component({
    selector: 'app-authorise',
    templateUrl: './authorise.component.html',
    styleUrls: [],
    standalone: false
})
export class AuthoriseComponent implements OnInit {

  constructor(
    private readonly _router: Router,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _loginService: LoginService
  ) { }

  ngOnInit(): void {
    const AUTH_CODE = this._activatedRoute.snapshot.queryParams?.code;
    if (AUTH_CODE) {
      this._loginService.loginUserWithOAuthCode(AUTH_CODE).then(() => {
        this._router.navigate(['/overview']);
      }).catch(() => {
        this._router.navigate(['login']);
      });
    } else {
      this._router.navigate(['login']);
    }
  }
}
